/*
 * View for the count of items checked
 */

define([
  "marionette",
  "modules/shared/sortableList/sortableListCounter/template/sortableListCounterTemplate.html",
], function (Marionette, SortableListCounterTemplate) {
  var SortableListCounterView = {};

  SortableListCounterView.sortableListCounterView = Marionette.ItemView.extend({
    template: SortableListCounterTemplate,
    modelEvents: {
      change: "render",
    },
  });

  return SortableListCounterView;
});
